import React from "react";
import PropTypes from "prop-types";
import { svgAsDataUri, saveSvgAsPng } from "save-svg-as-png";

import { Button, Columns } from "@namroodinc/ni-ui";

const SavePlayingArea = ({ playingAreaRef }) => {
  const handleSavePlayingArea = (type = "svg") => {
    switch (type) {
      case "png":
        saveSvgAsPng(playingAreaRef.current, `fileName.png`, {
          scale: 2
        });
        break;
      case "svg":
      default:
        svgAsDataUri(playingAreaRef.current, {}, (uri) => {
          const a = document.createElement("a");
          a.href = uri;
          a.download = `fileName.svg`;
          a.click();
        });
    }
  };

  return (
    <Columns numberOfColumns={2}>
      <Button
        label="Save as SVG"
        onClick={() => handleSavePlayingArea("svg")}
        size="small"
      />
      <Button
        label="Save as PNG"
        onClick={() => handleSavePlayingArea("png")}
        size="small"
      />
    </Columns>
  );
};

SavePlayingArea.defaultProps = {
  playingAreaRef: React.createRef()
};

SavePlayingArea.propTypes = {
  playingAreaRef: PropTypes.object
};

export default SavePlayingArea;
